import * as React from 'react';
import { useSelector } from 'react-redux';

import { IVillage, Villages } from '../../../components/countryside/Villages/Villages';
import { selectSubdomainRegionId } from '../../../selectors/countryside';

import village1 from './assets/village1.jpg';
import village2 from './assets/village2.jpg';
import village3 from './assets/village3.jpg';
import village4 from './assets/village4.jpg';
import village_spb1 from './assets/village-spb1.jpg';
import village_spb2 from './assets/village-spb2.jpg';
import village_spb3 from './assets/village-spb3.jpg';
import village_spb4 from './assets/village-spb4.jpg';

const MOSCOW_REGION_ID = 1;
const MOSCOW_WITH_AREA_REGION_ID = -1;
const MOSCOW_AREA_REGION_ID = 4593;
const ST_PETERSBURG_REGION_ID = 2;
const ST_PETERSBURG_WITH_AREA_REGION_ID = -2;
const ST_PETERSBURG_AREA_REGION_ID = 4588;

const VILLAGES_LINK = '/kottedzhnye-poselki/';
const AVAILABLE_IN_REGIONS = [
  MOSCOW_REGION_ID,
  MOSCOW_AREA_REGION_ID,
  MOSCOW_WITH_AREA_REGION_ID,
  ST_PETERSBURG_REGION_ID,
  ST_PETERSBURG_AREA_REGION_ID,
  ST_PETERSBURG_WITH_AREA_REGION_ID,
];
const MOSCOW_IDS = [MOSCOW_REGION_ID, MOSCOW_AREA_REGION_ID, MOSCOW_WITH_AREA_REGION_ID];

const villagesDataMoscow: IVillage[] = [
  {
    id: 1356,
    name: 'КП «Александровы пруды»',
    priceDisplay: '3 736 136',
    location: 'Варшавское шоссе, 23 км до\u00A0МКАД',
    imageUrl: village1,
    url: '/kottedzhnyj-poselok-aleksandrovy-prudy-1356/',
  },
  {
    id: 2178,
    name: 'КП «Европейская долина 2»',
    priceDisplay: '3 700 000',
    location: 'Малое Московское кольцо, 21 км до\u00A0МКАД',
    imageUrl: village2,
    url: '/kottedzhnyj-poselok-evropejskaya-dolina-2-2178/',
  },
  {
    id: 82906,
    name: 'КП «Riga Family»',
    priceDisplay: '9 800 000',
    location: 'Новорижское шоссе, 57 км до\u00A0МКАД',
    imageUrl: village3,
    url: '/kottedzhnyj-poselok-riga-family-82906/',
  },
  {
    id: 2175,
    name: 'КП «Петрово-Дальнее»',
    priceDisplay: '31 000 000',
    location: 'Новорижское шоссе, 12 км до\u00A0МКАД',
    imageUrl: village4,
    url: '/kottedzhnyj-poselok-petrovodalnee-2175/',
  },
];

const villagesDataSpb: IVillage[] = [
  {
    id: 1911,
    name: 'КП «Коркинские просторы»',
    priceDisplay: '1 114 200',
    location: 'Колтушское шоссе, 14 км до\u00A0КАД',
    imageUrl: village_spb1,
    url: '/kottedzhnyj-poselok-korkinskie-prostory-1911/',
  },
  {
    id: 1343,
    name: 'КП «Репинское»',
    priceDisplay: '19 800 000',
    location: 'Зеленогорское шоссе, 15 км до\u00A0КАД',
    imageUrl: village_spb2,
    url: '/kottedzhnyj-poselok-repinskoe-1343/',
  },
  {
    id: 1433,
    name: 'КП «Любовино»',
    priceDisplay: '7 585 000',
    location: 'Сортавала, 10 км до\u00A0КАД',
    imageUrl: village_spb3,
    url: '/kottedzhnyj-poselok-lyubovino-1433/',
  },
  {
    id: 4172,
    name: 'КП «Лехтуси»',
    priceDisplay: '650 000',
    location: 'Сортавала, 24 км до\u00A0КАД',
    imageUrl: village_spb4,
    url: '/kottedzhnyj-poselok-lehtusi-4172/',
  },
];

export const CountrysideVillagesContainer = () => {
  const subdomainRegionId = useSelector(selectSubdomainRegionId);
  const isMoscow = MOSCOW_IDS.includes(subdomainRegionId);

  if (!AVAILABLE_IN_REGIONS.includes(subdomainRegionId)) {
    return null;
  }

  return <Villages villagesData={isMoscow ? villagesDataMoscow : villagesDataSpb} villagesLink={VILLAGES_LINK} />;
};
